// DateSelector — ActivityWizard Steg 2 (delspår 3c). Wraps the shared shadcn
// Calendar (DayPicker). min = today (past days disabled). Stockholm-local date.

import { Calendar } from "@/components/ui/calendar";

interface DateSelectorProps {
  value: string | null;
  onSelect: (iso: string) => void;
}

function toISODate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default function DateSelector({ value, onSelect }: DateSelectorProps) {
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <div data-testid="date-selector" className="flex justify-center">
      <Calendar
        mode="single"
        selected={selected}
        onSelect={(d) => {
          if (d) onSelect(toISODate(d));
        }}
        disabled={{ before: today }}
        showWeekNumber={false}
        className="rounded-2xl border"
        /* R-3: the primary-dot "today" is now calendar.tsx's shared default —
           the wizard-only day_today override is redundant and removed. */
      />
    </div>
  );
}
